import { useEffect, useState } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';

import { Timeframe, TimeframeButtonGroup } from '@/components/spotter/notificationTab/TimeframeButtonGroup';
import { useDateRangeContext } from '@/context/DateRangeContext';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useTimedUsage } from '@/hooks/useTimedUsage';

const MAP_TIMEFRAME_OPTIONS: Timeframe[] = [
    [6, 'hours'],
    [3, 'hours'],
    [1, 'hours'],
];

const DEV_MAP_TIMEFRAME_OPTIONS: Timeframe[] = [
    [2, 'days'],
    [1, 'days'],
    [12, 'hours'],
    [6, 'hours'],
    [3, 'hours'],
    [1, 'hours'],
];

export const MapTimeframeSelector = () => {
    const mixpanel = useMixpanel();
    const { setTimeframe: setContextTimeframe } = useDateRangeContext();
    const [timeframe, setTimeframe] = useState<Timeframe>([6, 'hours']);
    const devMapTimeframeOptionsFlag = useFeatureFlag('devTimeframeOptions');

    useTimedUsage('Acoustics timeframe usage', { timeframe: timeframe.join(' ') });

    const handleTimeframeChange = (newTimeframe: Timeframe) => {
        mixpanel?.track('Change acoustics timeframe', {
            fromTimeframe: timeframe.join(' '),
            toTimeframe: newTimeframe.join(' '),
        });
        setTimeframe(newTimeframe);
    };

    useEffect(() => {
        // propagating timeframe as an effect because DateRangeContext doesn't expose the current timeframe (because it's not limited to single-unit intervals)
        setContextTimeframe(...timeframe);
    }, [timeframe, setContextTimeframe]);

    return (
        <TimeframeButtonGroup
            sx={{
                backgroundColor: 'white',
                height: '32px',
                boxShadow: 1,
            }}
            onTimeframeChange={handleTimeframeChange}
            currentTimeframe={timeframe}
            availableTimeframes={devMapTimeframeOptionsFlag ? DEV_MAP_TIMEFRAME_OPTIONS : MAP_TIMEFRAME_OPTIONS}
        />
    );
};
